module.exports = __webpack_public_path__ + "img/members-icon.c85cf006.svg";